import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./Home.css";
//import SidebarLeft from "../SidebarLeft";
//import SidebarRight from "../SidebarRight";
import "./CallsAwards.css";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";
function DsmSupportedEvents() {
  const [contentDsmSupportedEvents, setContentDsmSupportedEvents] =
    useState(null);
  /*
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  */

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_dsm_supported_events`)
      .then((response) => {
        const data = response.data;
        setContentDsmSupportedEvents(data);
      })
      .catch((error) => {
        //alert("ERRORE | get_dsm_supported_events");
        /*console.log(
          "DsmSupportedEvents | get_dsm_supported_events | error",
          error
        );
        */
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  /*
  const circleImg = (img) => {
    const src = `${serverConfig.serverUrl}/img/dsm_supported_events/${img}`; // Percorso dell'immagine
    const handleImageError = (event) => {
      event.target.src = ""; // Imposta l'immagine di fallback su una stringa vuota per evitare il loop di ricaricamento
      event.target.style.backgroundColor = "white"; // Imposta lo sfondo bianco
    };
    return (
      <div>
        <img
          src={src}
          style={{
            //width: "300px",
            //height: "150px",
            width: "100%",
            height: "100%",
            display: "block",
            backgroundColor: "transparent", // Imposta lo sfondo trasparente per mostrare il bianco dietro in caso di errore
            borderRadius: "5%",
          }}
          onError={handleImageError} // Ascolta l'evento onError per gestire l'errore di caricamento dell'immagine
          draggable={false}
        />
      </div>
    );
  };
  */

  const circleImg = (img) => {
    const src = `${serverConfig.serverUrl}/img/dsm_supported_events/${img}`; // Percorso dell'immagine

    const handleImageError = (event) => {
      event.target.style.display = "none"; // Nasconde l'immagine in caso di errore
      event.target.parentNode.style.backgroundColor = "none"; // Imposta lo sfondo nero del div contenitore
    };

    return (
      <div
        style={{
          width: "350px",
          height: "150px",
          backgroundColor: "transparent", // Sfondo trasparente di default
          borderRadius: "5%", // Bordo arrotondato del div
          display: "flex", // Centra il contenuto in caso di errore
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={src}
          style={{
            width: "350px",
            height: "100%",
            display: "block",
            objectFit: "contain",
            borderRadius: "5%",
          }}
          onError={handleImageError} // Ascolta l'evento onError per gestire l'errore di caricamento dell'immagine
          draggable={false}
          //alt="Image"
          alt=""
        />
      </div>
    );
  };

  const handleDownloadClick = (event, fileUrl) => {
    event.preventDefault();
    axios
      .get(`${serverConfig.serverUrl}/file/dsm_supported_events/${fileUrl}`, {
        responseType: "blob", // Indica ad Axios che la risposta è un blob (file)
      })
      .then((response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileUrl.split("/").pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        //alert("'Errore durante il download del file");
        toast.error("La risorsa non è al momento scaricabile");
      });
  };

  /*
  const getDayOfWeek = (dateString) => {
    const dateParts = dateString.split("-");
    if (dateParts[1].length === 1) {
      dateParts[1] = "0" + dateParts[1];
    }
    if (dateParts[2].length === 1) {
      dateParts[2] = "0" + dateParts[2];
    }
    const formattedDateString = dateParts.join("-");
    const date = new Date(formattedDateString);
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return daysOfWeek[date.getDay()];
  };
  */

  /*
  const componentsDsmSupportedEvents = (component) => {
    const file = component.file;
    const img = component.img;
    const link = component.link;
    const start = component.start_date;
    const dayStart = getDayOfWeek(start);
    const end = component.end_date;
    const dayEnd = getDayOfWeek(end);

    return (
      <>
        <div className="conference-items" style={{ marginBottom: "5px" }}>
          <div className="conference-item">
            <div className="conference-img-large">{circleImg(img)}</div>
            <div className="conference-item-content">
              {file && file !== "" && (
                <div>
                  <a
                    href={`${serverConfig.serverUrl}/file/dsm_supported_events/${file}`}
                    download // Aggiunge l'attributo download
                    rel="noopener noreferrer"
                    style={{ marginRight: "20px" }}
                    onClick={(e) => handleDownloadClick(e, file)}
                    draggable={false} // Impedisce il trascinamento
                    onDragStart={(e) => e.preventDefault()} // Impedisce l'azione di trascinamento
                  >
                    <button
                      style={{
                        borderRadius: "5px",
                        backgroundColor: "blue",
                        border: "white",
                        color: "white",
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-file-earmark-arrow-down"
                        viewBox="0 0 16 16"
                        style={{ marginRight: "10px" }}
                      >
                        <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                        <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                      </svg>
                      DOWNLOAD THE FILE - {file}
                    </button>
                  </a>
                </div>
              )}
              {link && link != "" && (
                <div>
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-link-45deg"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
                      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
                    </svg>
                    OPEN INFO IN NEW TAB
                  </a>
                </div>
              )}
              {start && start != "" && (
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-play-circle"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "10px", color: "green" }}
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                  </svg>
                  {dayStart} - {start}
                </div>
              )}
              {end && end != "" && (
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-stop-circle"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "10px", color: "red" }}
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
                  </svg>
                  {dayEnd} - {end}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };
  */

  const componentsDsmSupportedEvents = (group, items) => {
    // Divide gli elementi in coppie per visualizzarli in due colonne per riga
    const pairs = [];
    for (let i = 0; i < items.length; i += 2) {
      pairs.push(items.slice(i, i + 2));
    }
    return (
      <div className="conference-items">
        <div
          style={{
            color: "#F5F7FA",
            textAlign: "center",
            fontSize: "20px",
            borderRadius: "10px",
            border: "2px solid #D8DEE9",
            backgroundColor: "#003366",
          }}
        >
          {group}
        </div>
        {pairs.map((pair, pairIndex) => (
          <div className="row" key={pairIndex}>
            {pair.map((item, itemIndex) => (
              <div className="col-12 col-lg-6" key={itemIndex}>
                {/*<a href={item.link} className="conference-item-link">*/}
                <div className="conference-item">
                  <div className="conference-item-title">
                    {item.title && (
                      <div>
                        <h1>{item.title}</h1>
                      </div>
                    )}
                  </div>
                  <div className="conference-item-content-details">
                    <div className="conference-img-large">
                      <div>{circleImg(item.img)}</div>
                    </div>

                    <div className="conference-item-content">
                      {item.start && item.start !== "" && (
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-play-circle"
                            viewBox="0 0 16 16"
                            style={{ marginRight: "10px", color: "green" }}
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                          </svg>
                          {item.dayStart} - {item.start}
                        </div>
                      )}
                      {item.end && item.end !== "" && (
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-stop-circle"
                            viewBox="0 0 16 16"
                            style={{ marginRight: "10px", color: "red" }}
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
                          </svg>
                          {item.dayEnd} - {item.end}
                        </div>
                      )}
                      {item.text && (
                        <div dangerouslySetInnerHTML={{ __html: item.text }} />
                      )}
                    </div>
                  </div>

                  {item.file && item.file !== "" && (
                    <div>
                      {/*

                        <a
                          href={`${serverConfig.serverUrl}/file/dsm_supported_events/${item.file}`}
                          download // Aggiunge l'attributo download
                          rel="noopener noreferrer"
                          style={{ marginRight: "20px" }}
                          onClick={(e) => handleDownloadClick(e, item.file)}
                          draggable={false} // Impedisce il trascinamento
                          onDragStart={(e) => e.preventDefault()} // Impedisce l'azione di trascinamento
                        >
                          <button
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "blue",
                              border: "white",
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-file-earmark-arrow-down"
                              viewBox="0 0 16 16"
                              style={{ marginRight: "10px" }}
                            >
                              <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                            </svg>
                            DOWNLOAD THE FILE
                          </button>
                        </a>
 */}

                      <a
                        href={`${serverConfig.serverUrl}/file/dsm_supported_events/${item.file}`}
                        download
                        className="btn btn-primary ms-2"
                        onClick={(e) => handleDownloadClick(e, item.file)}
                      >
                        SCARICA
                      </a>
                    </div>
                  )}
                  {item.link && item.link !== "" && (
                    <div>
                      <button
                        className="btn btn-outline-primary"
                        onClick={() =>
                          window.open(
                            `${item.link}`,
                            "_blank"
                          )
                        }
                      >
                        APRI IN UNA NUOVA FINESTRA
                      </button>

                      {/*
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-link-45deg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
                          <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
                        </svg>
                        OPEN INFO IN NEW TAB
                      </a>
                      */}
                    </div>
                  )}
                </div>
                {/*</a>*/}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const viewDsmSupportedEvents = (
    <>
      {/*
      {contentDsmSupportedEvents != null && (
        <div className="row" style={{ padding: "10px" }}>
          {Object.keys(contentDsmSupportedEvents)
            .sort((a, b) => b - a) // Ordina le chiavi in ordine decrescente
            .map((key) =>
              contentDsmSupportedEvents[key].map((item, index) =>
                componentsDsmSupportedEvents(item)
              )
            )}
        </div>
      )}
      */}

      {contentDsmSupportedEvents && (
        <div>
          {Object.entries(contentDsmSupportedEvents)
            .sort(([groupA], [groupB]) => groupB - groupA) // Ordina per chiave `group`
            .map(([group, items]) => (
              <div key={group}>
                {componentsDsmSupportedEvents(group, items)}
              </div>
            ))}
        </div>
      )}
    </>
  );

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const componentDsmSupportedEvents = <>{viewDsmSupportedEvents}</>;

  return (
    <div>
      {/*}
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">{viewDsmSupportedEvents}</div>
      </div>
      */}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>
              {componentDsmSupportedEvents}
            </div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {componentDsmSupportedEvents}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DsmSupportedEvents;
